export const CollectionMethods = Object.freeze({
  // These enum values map to values from OHI
  DIRECT_DEBIT: 'DD',
  INVOICE: 'BILL',
});

export default CollectionMethods;
